export default __webpack_public_path__ + "static/media/Oki.2cc459a5.webp";